export const attachments = {
  mainSectionHeader: 'Fișiere atașate',
  noFiles: 'Nu există fișiere atașate',
  delete: 'Confirmi ștergerea?',
  deleteModal: {
    title: 'Ștergere fișier atașat',
    question: 'Confirmi ștergerea acestui fișier?',
    irreversibleNotice: 'Această acțiune este ireversibilă.',
    btn: {
      cancel: 'Renunță',
      confirm: 'Șterge'
    }
  },
  loading: 'Atașează fișier',
  reload: 'Re-încarcă',

  mimesInvalid: 'Fișier invalid',
  sizeInvalid: 'Mărimea maximă acceptabilă a fost depășită',

  choseFilePlaceholder: 'Alege un fișier...',
  dropFilePlaceholder: 'Trage un fișier aici...',
  dropzoneLabel: 'Trage fișierul aici pentru a-l atașa',

  downloadFileTooltip: 'Descarcă',
  deleteFileTooltip: 'Șterge',

  toasts: {
    errorTitle: 'Eroare',
    successTitle: 'Succes',

    uploadedSuccessfully: 'Fișierul a fost atașat',
    uploadFileError: 'Eroare la atașarea fișierului',
    uploadFileServerError: 'Eroare de server la atașarea fișierului',

    getFilesError: 'Eroare la încărcarea fișierelor atașate',
    getFilesServerError: 'Eroare de server la încărcarea fișierelor atașate',

    deletedSuccessfully: 'Fișierul a fost șters',
    deleteFileError: 'Eroare la ștergerea fișierului',
    deleteFileServerError: 'Eroare de server la ștergerea fișierului'
  },

  btn: {
    addAttachment: 'Adaugă fișier',
    attach: 'Atașează',
    cancel: 'Renunță'
  }
}
